/* istanbul ignore next */
const ACTIONS = {
    FETCH_INITIAL_DATA_SUCCESS: 'FETCH_INITIAL_DATA_SUCCESS',
    TRIGGER_EDAP_PAGEVIEW: 'TRIGGER_EDAP_PAGEVIEW',
    TRIGGER_EDAP_EVENT: 'TRIGGER_EDAP_EVENT',
    ENABLE_LOAD_OVERLAY: 'ENABLE_LOAD_OVERLAY',
    CHANGE_APP_STATE: 'CHANGE_APP_STATE',
    CREATE_OWNER_ACCOUNT: 'CREATE_OWNER_ACCOUNT',
    AUTHENTICATE_USER: 'AUTHENTICATE_USER',
    SET_CAPTCHA_RESP: 'SET_CAPTCHA_RESP',
    SAVE_COMPONENT_STATE: 'SAVE_COMPONENT_STATE',
    SHOW_SAVE_AND_FINISH_MODAL: 'SHOW_SAVE_AND_FINISH_MODAL',
    DELETE_COMPONENT_STATE: 'DELETE_COMPONENT_STATE',
    SHOW_INELIGIBLE_FORM: 'SHOW_INELIGIBLE_FORM',
    SAVE_COMPONENT_PATH: 'SAVE_COMPONENT_PATH',
    SAVE_DEEP_LINK_PARAMS: 'SAVE_DEEP_LINK_PARAMS',
    SAVE_PREFERRED_LOCALE: 'SAVE_PREFERRED_LOCALE',
    GET_ABACUS_EXP_FLAG: 'GET_ABACUS_EXP_FLAG'
};

/* istanbul ignore next */
const ACTION_CREATORS = {
    fetchInitialDataSuccess(response) {
        return {
            type: ACTIONS.FETCH_INITIAL_DATA_SUCCESS,
            payload: {
                response
            }
        };
    },

    triggerEdapPageView(publicUuid, pagename) {
        return {
            type: ACTIONS.TRIGGER_EDAP_PAGEVIEW,
            payload: {
                publicUuid,
                pagename
            }
        };
    },

    triggerEdapEvent(eventName, eventData, options) {
        return {
            type: ACTIONS.TRIGGER_EDAP_EVENT,
            payload: {
                eventName,
                eventData,
                options
            }
        };
    },

    enableLoadOverLay(flag) {
        return {
            type: ACTIONS.ENABLE_LOAD_OVERLAY,
            payload: {
                flag
            }
        };
    },

    changeAppState(state) {
        return {
            type: ACTIONS.CHANGE_APP_STATE,
            payload: {
                state
            }
        };
    },

    showIneligibleForm(type) {
        return {
            type: ACTIONS.SHOW_INELIGIBLE_FORM,
            payload: {
                type
            }
        };
    },

    authenticateUser(entryTicketId, accountDetails) {
        return {
            type: ACTIONS.AUTHENTICATE_USER,
            payload: {
                entryTicketId,
                accountDetails
            }
        };
    },

    addOwnerAccount() {
        return {
            type: ACTIONS.CREATE_OWNER_ACCOUNT
        };
    },

    setCaptchaResponse(type, response) {
        return {
            type: ACTIONS.SET_CAPTCHA_RESP,
            payload: {
                type,
                response
            }
        };
    },

    saveComponentState(componentName, componentState) {
        return {
            type: ACTIONS.SAVE_COMPONENT_STATE,
            payload: {
                componentName,
                componentState
            }
        };
    },

    saveComponentPath(path) {
        return {
            type: ACTIONS.SAVE_COMPONENT_PATH,
            payload: {
                path
            }
        };
    },

    showSaveAndFinishModal(flag) {
        return {
            type: ACTIONS.SHOW_SAVE_AND_FINISH_MODAL,
            payload: {
                flag
            }
        };
    },

    deleteComponentState() {
        return {
            type: ACTIONS.DELETE_COMPONENT_STATE
        };
    },

    saveDeepLinkParams(paramType, deepLinkParams) {
        return {
            type: ACTIONS.SAVE_DEEP_LINK_PARAMS,
            payload: {
                paramType,
                deepLinkParams
            }
        };
    },

    // This action is not currently used anywhere
    getAbacusExpFlag(experimentNames, siteName) {
        return {
            type: ACTIONS.GET_ABACUS_EXP_FLAG,
            payload: {
                experimentNames,
                siteName
            }
        };
    },

    savePreferredLocale(publicUuid, locale) {
        return {
            type: ACTIONS.SAVE_PREFERRED_LOCALE,
            payload: {
                publicUuid,
                locale
            }
        };
    }
};

export default {
    ...ACTIONS,
    ...ACTION_CREATORS
};
